const ethinicityDisplayOptions = [
  { value: '0', label: 'Select'},
  { value: '1', label: 'Hispanic' },
  { value: '2', label: 'Not Hispanic'},
  { value: '3', label: 'Unknown'}, 
]

export default ethinicityDisplayOptions
